// extracted by mini-css-extract-plugin
module.exports = {"product-details-animation":"product-details_product-details-animation__2IxpD","hide":"product-details_hide__2YCxX"};